import { useAuth } from '@/features/auth/AuthContext';

/**
 * SaaS gating for task-creation controls. `gated` is true on the SaaS
 * deployment (only classification / non-agentic tasks are self-serve);
 * `contactUs` is the modal opener when the backend can file a
 * customers-intents request, otherwise undefined (tooltip shows plain copy).
 */
export default function useSaasGating(onContactUs) {
    const auth = useAuth();
    const gated = auth?.isSaas === true;
    const contactUs = gated && auth?.customerIntentsEnabled === true ? onContactUs : undefined;
    return { gated, contactUs };
}
